export const MENU_COLLAPSE_BREAKPOINT = 1320;

export const BREADCRUMB_HEIGHT = 52;

export const HEADER_HEIGHT = 80;
